// Reads the optional `scope` envelope on a resolved visualization payload and
// tells whether it reports the leader-count gate as not met — i.e. fewer
// leaders than the minimum required to safely show aggregate results
// (leaderCount < leaderGateMin, falling back to 10 when the server omits it).
const LEADER_GATE_MIN_FALLBACK = 10;
export const isLeaderGateNotMetFromData = (data) => {
    const scope = data && data.scope;
    if (!scope) return false;
    if (typeof scope.leaderCount === 'number') {
        const gateMin = typeof scope.leaderGateMin === 'number' ? scope.leaderGateMin : LEADER_GATE_MIN_FALLBACK;
        return scope.leaderCount < gateMin;
    }
    // No explicit count — fall back to the server's gated flag/reason.
    return !!(scope.gated && scope.reason === 'LEADER_GATE_NOT_MET');
};

export const handleVisualizationStateStart = (state, payload) => {
    return {
        ...state,
        [payload.apiName]: {
            ...state[payload.apiName],
            isProcessing: true,
            error: false,
            reason: '',


        },
        // Clear the sticky gate flag/counts at the start of a fresh fetch cycle
        // so a re-applied filter is re-evaluated. Every visualization API's START
        // is dispatched synchronously (in callVisualizationApis) before any
        // SUCCESS resolves, so this reset always lands ahead of the responses
        // that set it.
        isLeaderGateNotMet: false,
        leaderGateScope: null,
        // No verdict in this cycle yet — set again by the first response below.
        hasVisualizationResponse: false,


    };
};

export const handleVisualizationStateSuccess = (state, payload) => {
    const data = payload.data && payload.data.data && payload.data.data ? payload.data.data : null;
    const gateNotMet = isLeaderGateNotMetFromData(data);
    return {
        ...state,
        [payload.apiName]: {
            ...state[payload.apiName],
            isProcessing: false,
            error: false,
            reason: '',
            data,
        },
        isVisualizationDataFectched: true,
        // A section has reported, whatever it reported — so the gate flag below
        // can now be read as an answer rather than as a default.
        hasVisualizationResponse: true,
        // Set once when any section reports the gate isn't met; the OR keeps an
        // already-set flag from being cleared by a later, non-gated response in
        // the same batch (reset only happens on the next fetch's START).
        isLeaderGateNotMet: state.isLeaderGateNotMet || gateNotMet,
        // Capture the counts from the first gated scope only; keep them once set.
        leaderGateScope: state.isLeaderGateNotMet
            ? state.leaderGateScope
            : (gateNotMet
                ? {
                    completedSelfCount: data.scope.leaderCount,
                    leaderGateMin: typeof data.scope.leaderGateMin === 'number' ? data.scope.leaderGateMin : LEADER_GATE_MIN_FALLBACK,
                }
                : state.leaderGateScope),

    };
};

export const handleVisualizationStateFail = (state, payload) => {
    return {
        ...state,
        [payload.apiName]: {
            ...state[payload.apiName],
            isProcessing: false,
            error: true,
            reason: '',
            data: null,
        },
        isProcessing: false,
        error: false, reason: '',
        isVisualizationDataFectched: false

    };
};
